import { slice } from './slice';

export const { setCurrentUser, clearCurrentUser } = slice.actions;

export const { currentUserState } = slice.selectors;

export type { State as CurrentUserState } from './state.type';
